import { gql } from 'graphql.macro';

export const invoicePartyFragment = gql`
    fragment invoicePartyFields on InvoiceParty {
        reference
        name
        number
        contact {
            address {
                street
                city
                postalCode
                country
            }
            communication {
                phone
                email
                site
            }
        }
        countryCode
    }
`;
export const invoiceFragment = gql`
    fragment invoiceFields on Invoice {
        _id
        invoiceNumber
        currency
        invoiceText
        supplier {
            ...invoicePartyFields
        }
        customer {
            ...invoicePartyFields
        }
        deliveryAddress {
            ...invoicePartyFields
        }
        createdDate
        invoiceDate
        isCredited
        description
        orderNumber
        vatNumber
        ocrNumber
        dueDate
        type
        sentDate
        paidOn
        paymentStatus
        invoiceType
        pdfUrl
        deliveryNotesPdfUrl
        invoiceSpecificationPdfUrl
        status
        processingErrorMessage
        paymentTerm
        deliveryMethod
        ourReference
        total {
            total
            currency
            vat
            totalIncVat
        }
        debitInvoice {
            _id
            invoiceNumber
            total {
                total
                currency
                vat
                totalIncVat
            }
        }
        creditInvoices {
            _id
            invoiceNumber
            total {
                total
                currency
                vat
                totalIncVat
            }
        }
    }
    ${invoicePartyFragment}
`;

export const invoiceLineItemFragment = gql`
    fragment invoiceLineItemFields on InvoiceLineItem {
        currency
        order {
            _id
            orderId
            isCertified
            restorations {
                _id
                actions {
                    _id
                    code
                    name
                    price {
                        quantity
                        unitPrice
                        vatPercent
                        totalWithoutVat
                        totalWithVat
                    }
                }
                materials {
                    _id
                    code
                    name
                    price {
                        quantity
                        unitPrice
                        vatPercent
                        totalWithoutVat
                        totalWithVat
                    }
                }
            }
            certified {
                by {
                    _id
                    name {
                        firstName
                        lastName
                    }
                }
            }
        }
        note {
            _id
        }
        description
        quantity
        isIdentifyingRow
        itemPrice
        itemVat
        itemVatPercentage
        vatTreatment
        totalIncVat
    }
`;

export const reviewOrderFragment = gql`
    fragment reviewOrderFields on ReviewOrder {
        _id
        clinicId
        parentClinicId
        clinicName
        currency
        ptjCustomerNumber
        orderId
        orderStatus
        deliveryDate
        orderCreatedDate
        pdfUrl
        invoiceStatus
        invoiceType
        tempInvoiceNumber
        invoicingState
        clinicInvoiceType
        clinicInvoiceDeliveryMethod
        clinicInvoiceEmail
        isProductionFinished
        invoiceNumber
        invoiceSentDate
        totalAmount {
            totalPrice
            vatAmount
            averagePrice
        }
        clientInvoiceSettings {
            invoiceType
            invoiceDelivery
            invoiceEmail
        }
    }
`;

export const invoiceNoteFragment = gql`
    fragment invoiceNoteFields on InvoiceNote {
        _id
        type
        currency
        clinic {
            _id
            name
            invoiceType
        }
        dentist {
            _id
            fullName
        }
        lab
        invoice {
            _id
            invoiceNumber
        }
        description
        itemPrice
        quantity
        itemVatPercentage
        itemVat
        totalExclVat
        totalIncVat
    }
`;
